module.exports = __webpack_public_path__ + "img/fr.a573a70c.svg";